export default function disclaimerA(text) {
  return {text: ` ${text}`, style: 'disclaimerA'}
}
